import { useSocket, useSocketEvent } from 'hooks/useSocket';
import SubmissionFilter from 'types/SubmissionFilter';
import UgcRequest from 'types/UgcRequest';
import { LumenButton } from '@photoshelter/socialie-components';
import { useTranslation } from 'react-i18next';
import { useExportSubmissionsMutation } from 'api/submissions';
import { useState } from 'react';
import useFlashMessages from 'hooks/useFlashMessages';

interface Props {
  request: UgcRequest;
  filter: SubmissionFilter;
  selectedIds: (string | number)[];
  totalCount: number;
}

export default function SubmissionExport(props: Props) {
  const { request, filter, selectedIds, totalCount } = props;
  const { t } = useTranslation();
  const { socketId } = useSocket();
  const [taskId, setTaskId] = useState<number | null>(null);
  const count = selectedIds.length > 0 ? selectedIds.length : totalCount;
  const { addFlashMessage } = useFlashMessages();

  const [exportSubmissions] = useExportSubmissionsMutation();

  // Redirect to the download URL when the task is completed
  useSocketEvent(
    'taskUpdated',
    (params: { task: { id: number; output: { url: string } } }) => {
      if (params.task.id === taskId) {
        setTaskId(null);
        window.location.href = params.task.output.url;
      }
    }
  );

  if (!count) return null;

  return (
    <LumenButton
      color="outline"
      leftIcon="xls-outline"
      isLoading={!!taskId}
      onClick={async () => {
        const response = await exportSubmissions({
          requestId: request.id,
          filter,
          selectedIds,
          socketId,
        });
        if ('error' in response) {
          console.error(response.error);
          addFlashMessage(t('global.unexpectedError'), { isError: true });
        } else {
          setTaskId(response.data.taskId);
        }
      }}
    >
      {t('ugcRequestShow.export', { count })}
    </LumenButton>
  );
}
